/**
 * Nombre visible de cada origen de asiento (Asiento::ORIGIN_* en el backend).
 * El backend ya devuelve origin_type_label; este mapa solo arma el combo de filtro.
 */
const ORIGINS = {
  voucher: "Factura",
  spent: "Gasto",
  charge: "Cobro",
  spent_payment: "Pago",
  tesoreria_movement: "Movimiento de Tesorería",
  cheque: "Cheque",
  manual: "Manual",
  cierre: "Cierre",
  apertura: "Apertura",
};

/** Origenes como [{ id, name }] para un combo. */
function originItems() {
  return Object.keys(ORIGINS).map((id) => ({ id: id, name: ORIGINS[id] }));
}

export default {
  originItems,
};
